<template>
  <media-item :thumbnail="item.thumbnail" :src="this.item.src">
    <div class="media-text">
      <p>{{ item.description }}</p>
      <a :href="item.link" v-if="item.link" class="button">{{ item.cta }}</a>
      <router-link v-if="item.route" :to="route" class="button">{{ item.cta }}</router-link>

    </div>
  </media-item>
</template>

<script>
import AbstractSection from './abstract'
import parseUrl from '@/filters/parseurl'
import MediaItem from '@/elements/media'

export default AbstractSection.extend({
  components: { MediaItem },
  computed: {
    route () {
      return parseUrl(this.item.route)
    }
  }
})
</script>

<style lang="scss" scoped>
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';

.media-text {
  padding-top: calc(#{$global-padding} * 3);

  @media #{$above-breakpoint-768} {
    flex: 0 1 25%;
    padding-top: 0;
    padding-left: calc(#{$global-padding} * 3);
  }

  p {
    @include font-size(16px, 18px);
    font-weight: bold;
    line-height: 1.4;

    &:before {
      content: "";
      display: block;
      margin-bottom: $global-padding;

      background: $color-red;
      height: 10px;
      width: 74px;
    }

    margin-bottom: calc(#{$global-padding} * 2);
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/media.vue